import React, { useState, useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";
import { Heading6, Body2 } from "app/popleads/components/ui-kit/Text";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import { useExtensionContext } from "app/popleads/modules/extension/ExtensionContext";
import useTaskComplete from "app/popleads/hooks/useTaskComplete";
import useTaskUpdate from "app/popleads/hooks/useTaskUpdate";
import useTaskImportant from "app/popleads/hooks/useTaskImportant";
import moment from "moment";
import { toAbsoluteUrl } from "_metronic/_helpers";
import { POPUP_CONTENTS } from "app/popleads/modules/extension/utils/constants";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CustomDatePicker from "app/popleads/components/ui-kit/DateInput";
import highlightFromTo from "app/popleads/modules/extension/utils/highlightFromTo";

const commonTextStyles = css`
    color: ${(props) => (props.selected ? colors.neutral[500] : colors.neutral[800])};
    font-size: 12px;
`;

const flexCenter = css`
    display: flex;
    align-items: center;
`;

const CardContainer = styled.div`
    background-color: ${(props) => (props.overdue ? "#FDF5F5" : colors.white)};
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    border: 1px solid ${(props) => (props.overdue ? "#F3B4B4" : colors.neutral[100])};
    position: relative;
    transition: all 0.2s ease-in-out;
    padding-top: 2px;
    padding-bottom: 2px;
    cursor: pointer;
    max-width: 100%;
    overflow: visible;

    padding-bottom: ${(props) => (props.isExpanded && !props.hideBulkActions ? "40px" : "0")};
    //z-index: ${(props) => (props.isExpanded || props.showDatePicker ? 10 : 1)};
    overflow: visible;


    .action-bar {
        visibility: ${(props) => (props.isExpanded && !props.hideBulkActions ? "visible" : "hidden")};
        opacity: ${(props) => (props.isExpanded && !props.hideBulkActions ? "1" : "0")};
        transform: translateY(${(props) => (props.isExpanded && !props.hideBulkActions ? "0" : "100%")});
    }

    .task-type-info {
        max-height: ${(props) => (props.isExpanded || props.showInlineInfo ? "50px" : "0")};
        overflow: hidden;
        transition: max-height 0.3s ease-in-out;
        display: ${(props) => (props.showInlineInfo ? "none" : "flex")};
    }
`;

/*const SelectionCheckbox = styled.div`
    width: 12px;
    height: 12px;
    min-width: 12px;
    min-height: 12px;
    border: 2px solid
        ${(props) => (props.selected ? (props.greyMode ? colors.l3rnTech[900] : "#00856C") : colors.neutral[500])};
    border-radius: 4px;
    ${flexCenter};
    justify-content: center;
    cursor: pointer;
    background-color: ${(props) =>
        props.selected ? (props.greyMode ? colors.l3rnTech[900] : "#00856C") : "transparent"};
    transition: all 0.2s ease;
    box-sizing: border-box;
    flex-shrink: 0;
    position: relative;
    opacity: ${(props) => (props.selected ? 1 : 0)};
    visibility: ${(props) => (props.selected ? "visible" : "hidden")};

    ${CardContainer}:hover & {
        opacity: 1;
        visibility: visible;
    }

    &:after {
        content: ${(props) => (props.selected ? "'✓'" : "''")};
        color: ${colors.white};
        font-size: 10px;
        font-weight: bold;
        line-height: 1;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;*/

const CardContent = styled.div`
    //padding: 8px;
    //padding-left: ${(props) => (props.isProfileTask ? "8px" : "32px")};
    padding-right: 8px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
`;

const DetailContent = styled.div`
    max-height: ${(props) => (props.isExpanded ? "500px" : "0")};
    opacity: ${(props) => (props.isExpanded ? "1" : "0")};
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    padding: 0px 0px 0px 4px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: visible;
`;
const Title = styled(Heading6)`
    color: ${(props) => (props.selected ? colors.neutral[500] : colors.neutral[800])};
    font-size: 12px;
    font-weight: 500;
    ${flexCenter};
    justify-content: space-between;
    gap: 8px;
    //margin-bottom: 4px;
    width: 100%;
    //align-items: ${(props) => (props.isExpanded ? "baseline" : "center")};
    align-items: ${(props) => {
        if (props.isExpanded) return "baseline";
        return "center";
    }};


`;

/*const TitleContent = styled.div`
    * {
        margin: 0;
        padding: 0;
    }
    font-size: 14px;
    color: ${colors.neutral[800]};
    font-weight: 400;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    hyphens: auto;
    max-width: 100%;

    ul {
        margin: 8px 0;
        padding-left: 20px;
        list-style-type: disc;
    }

    ol {
        margin: 8px 0;
        padding-left: 20px;
        list-style-type: decimal;
    }

    li {
        margin: 4px 0;
        line-height: 1.4;
    }

    ul ul,
    ol ol,
    ul ol,
    ol ul {
        margin: 4px 0;
        padding-left: 16px;
    }

    strong {
        font-weight: 600;
    }

    em {
        font-style: italic;
    }
`;*/

const TypeInfo = styled.div`
    font-size: 12px;
    font-weight: 500;
    color: ${colors.neutral[800]};
`;

const TypeInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0px;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    width: 100%;
`;

const ImportantBadge = styled.div`
    width: 18px;
    height: 18px;
    background-color: ${(props) => (props.important ? colors.danger[900] : colors.neutral[300])};
    border-radius: 50%;
    cursor: pointer;
    position: absolute;
    top: -6px;
    right: -8px;
    border: 2px solid ${colors.white};
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
    color: ${colors.white};
    line-height: 1;
    opacity: ${(props) => (props.important ? 1 : 0)};
    visibility: ${(props) => (props.important ? "visible" : "hidden")};

    ${CardContainer}:hover & {
        opacity: 1;
        visibility: visible;
    }

    &:hover {
        background-color: ${(props) => (props.important ? colors.danger[600] : colors.neutral[400])};
        transform: scale(1.1);
    }
`;

const Description = styled.div`
    color: ${(props) => (props.selected ? colors.neutral[500] : colors.neutral[800])};
    font-size: 14px;
    font-weight: 400;
    margin: 8px 0;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    hyphens: auto;
    max-width: 100%;
`;

const UserInfoWrapper = styled.div`
    ${flexCenter};
    justify-content: space-between;
`;

const UserInfo = styled.div`
    ${flexCenter};
`;

const UserAvatar = styled.img`
    width: 20px;
    height: 20px;
    border-radius: 50%;
`;

const UserName = styled(Heading6)`
    color: ${colors.neutral[900]};
    font-size: 12px;
    font-weight: 500;
    ${flexCenter};
    margin-left: 8px;
`;

const UserStatus = styled.span`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
`;

const DetailItem = styled.div`
    ${commonTextStyles};
    ${flexCenter};
    font-weight: ${(props) => props.weight || 400};
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    max-width: 100%;
`;

const IconDetailItem = styled.div`
    display: flex;
    ${commonTextStyles};
    font-weight: 500;
    gap: 8px;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    max-width: 100%;

    span {
        width: 16px;
        height: 16px;
        font-size: 16px;
        color: ${(props) => (props.selected ? colors.neutral[500] : "#5f6368")};
        flex-shrink: 0;
        line-height: 1.2;
    }
`;

const AssignedText = styled(Body2)`
    ${commonTextStyles};
`;

const CreatedText = styled(Heading6)`
    color: ${colors.neutral[500]};
    font-size: 12px;
    font-weight: 400;
`;

const Separator = styled.hr`
    border: none;
    height: 1px;
    background-color: ${colors.neutral[200]};
    margin: 0;
`;

const ActionBar = styled.div`
    ${flexCenter};
    background-color: ${colors.neutral[50]};
    justify-content: space-around;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    visibility: hidden;
    opacity: 0;
    transform: translateY(100%);
    transition: all 0.2s ease-in-out;
    padding: 8px 12px;
    border-top: 1px solid ${colors.neutral[100]};
    height: 40px;
    z-index: ${(props) => (props.$elevated ? 20 : 5)};
    border-radius: 0px 0px 6px 6px;
`;

const MoveDropdown = styled.div`
    position: absolute;
    background: ${colors.white};
    border: 1px solid ${colors.neutral[100]};
    border-radius: 6px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    padding: 8px 0;
    ${(props) =>
        props.$datePickerOpen
            ? "display: none !important; visibility: hidden !important; pointer-events: none !important;"
            : ""}
    ${(props) =>
        props.isFirst || props.isProfileTaskFirst
            ? `
                top: calc(100% + 8px);
                bottom: auto;
            `
            : `
                bottom: calc(100%);
                top: auto;
            `};
    left: 50%;
    transform: translateX(-50%);
    display: none;
    min-width: 120px;
    z-index: 100;

    &:after {
        content: "";
        position: absolute;
        ${(props) =>
            props.isFirst || props.isProfileTaskFirst
                ? `
                    top: -8px;
                    bottom: auto;
                `
                : `
                    bottom: -8px;
                    top: auto;
                `};
        left: 50%;
        transform: translateX(-50%);
        width: 16px;
        height: 16px;
        background: transparent;
    }

    &:before {
        content: "";
        position: absolute;
        ${(props) =>
            props.isFirst || props.isProfileTaskFirst
                ? `
                    top: -6px;
                    bottom: auto;
                    transform: translateX(-50%) rotate(225deg);
                `
                : `
                    bottom: -6px;
                    top: auto;
                    transform: translateX(-50%) rotate(45deg);
                `};
        left: 50%;
        width: 12px;
        height: 12px;
        background: ${colors.white};
        ${(props) =>
            props.isFirst
                ? "border-left: 1px solid " +
                  colors.neutral[100] +
                  "; border-top: 1px solid " +
                  colors.neutral[100] +
                  ";"
                : "border-right: 1px solid " +
                  colors.neutral[100] +
                  "; border-bottom: 1px solid " +
                  colors.neutral[100] +
                  ";"}
    }
`;

export const MoveOption = styled.div`
    padding: 8px 16px;
    color: ${colors.neutral[800]};
    font-size: 14px;
    cursor: pointer;

    &:hover {
        background: ${colors.neutral[50]};
    }
`;

const MoveButtonWrapper = styled.div`
    position: relative;
    padding: 4px 0;
    overflow: visible;

    &:hover ${MoveDropdown} {
        display: ${(props) => (props.showDatePicker ? "none" : "block")};
    }

    ${MoveDropdown}:hover {
        display: ${(props) => (props.showDatePicker ? "none" : "block")};
    }

    ${MoveDropdown} {
        display: ${(props) => (props.showDatePicker ? "none !important" : "none")};
    }
`;

const IconDetailWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

const DatePickerWrapper = styled.div`
    position: absolute;
    bottom: ${({ isFirst, isProfileTaskFirst }) =>
        isFirst ? "calc(100% - 215px)" : isProfileTaskFirst ? "calc(100% - 185px)" : "calc(100% - 90px)"};
    left: 50%;
    transform: translateX(-52%);
    z-index: 2000;
    //background: ${colors.white};
    border-radius: 8px;
    //box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    //border: 1px solid ${colors.neutral[200]};
`;
const ExpandableBox = styled.div`
    overflow: ${({ $expanded }) => ($expanded ? "visible" : "hidden")};
    display: ${({ $expanded }) => ($expanded ? "block" : "-webkit-box")};
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${({ $expanded }) => ($expanded ? "unset" : "1")};
    cursor: pointer;
`;

export const StyledNoteContent = styled.span`
    color: ${({ variant }) => (variant === "warning" ? colors?.warning[800] : colors.neutral[800])};
    font-size: 12px;
    font-weight: 400;
    letter-spacing: -0.17px;
    line-height: 21px;
    overflow-wrap: anywhere;

    ${({ variant }) => variant === "notEdit" && "cursor: pointer;"}
    & > p {
        margin: 0;
        display: ${({ isRelatedCustomer }) => (isRelatedCustomer ? "inline" : "block")};
    }

    & i {
        color: inherit;
        font-size: inherit;
        font-weight: inherit;
        letter-spacing: inherit;
        line-height: inherit;
    }
`;
const SelectableTaskCard = ({
    task,
    setTaskToDelete,
    overdue,
    selectedTasks,
    onTaskComplete,
    hasTaskPermission,
    handleNoPermission,
    isFirst = false,
    isProfileTask = false,
    index,
    isProfileTaskFirst = false,
    greyMode = false,
    hideBulkActions = false,
    isCompletedTask = false,
    isInOverduesPage = false,
    isExpanded: propIsExpanded,
    onToggleExpand,
    showInlineInfo = false,
    onDatePickerToggle,
}) => {
    const [localIsExpanded, setLocalIsExpanded] = useState(false);
    const isExpanded = propIsExpanded !== undefined ? propIsExpanded : localIsExpanded;

    const {
        modals,
        setState,
        refetchTaskList,
        selectedTasksId,
        fetchTaskLists,
        selectedDate,
        fetchStaticTaskList,
        editMode,
        selectedTask,
    } = useExtensionContext();
    const { user } = useSelector((state) => state.auth);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const datePickerWrapperRef = useRef(null);

    useEffect(() => {
        if (onDatePickerToggle) {
            onDatePickerToggle(showDatePicker);
        }
    }, [showDatePicker, onDatePickerToggle]);
    const [selectedTaskForMove, setSelectedTaskForMove] = useState(null);
    const [isMoveHovered, setIsMoveHovered] = useState(false);

    useEffect(() => {
        if (selectedTasksId && selectedTasksId === task.id) {
            if (onToggleExpand) {
                // External control handled by ExtensionTaskList
            } else {
                setLocalIsExpanded(true);
            }
        }
    }, [selectedTasksId, task.id, onToggleExpand]);

    const {
        id,
        metin: title,
        aciklama: description,
        zaman,
        createdTime,
        important,
        profilId: profileId,
        profil,
        taskColour: taskColor,
        assignedByName: assignedTo,
        type,
        activity,
        kayitci,
    } = task;

    const relatedCustomer = profil?.ad && profil?.soyad ? `${profil?.ad} ${profil?.soyad}` : null;

    const { ad, soyad, tel: phoneNumber, tel2, tel3, email, email2, resim, accountName } = profil || {};
    const userName = profil && (ad || soyad) ? `${ad || ""} ${soyad || ""}` : "";
    const defaultImage = toAbsoluteUrl("/media/users/default.jpg");
    const [imgSrc, setImgSrc] = useState(profil && resim ? resim : defaultImage);

    const hasUserInfo = profil;
    const hasDetailItems = profil && (phoneNumber || tel2 || tel3 || email || email2);

    const isEditingThisTask = editMode && selectedTask && selectedTask.id === id;

    const { completeTask } = useTaskComplete();
    const { updateTask } = useTaskUpdate();
    const { toggleTaskImportant } = useTaskImportant();

    const handleTaskCompletion = async (taskId) => {
        try {
            const response = await completeTask(taskId);
            if (response?.stat !== "ok") {
                throw new Error("Failed to complete task");
            } else {
                fetchTaskLists({ selectedDate });
                //refetchProfile();
                refetchTaskList();
                const messagePayload = {
                    message: "XPIDER_MESSAGE_NOTIFICATION",
                    task: {
                        id: taskId,
                        status: "completed",
                    },
                };
                window.parent.postMessage(messagePayload, "*");
                toast.success("Task completed");
            }
        } catch (error) {
            toast.error("Failed to complete task");
        }
    };

    const handleCheckboxClick = (e) => {
        e.stopPropagation();
        onTaskComplete(id);
    };

    const handleImportantToggle = async (e) => {
        e.stopPropagation();

        if (hasTaskPermission && handleNoPermission) {
            if (!hasTaskPermission(task)) {
                handleNoPermission();
                return;
            }
        }

        if (isEditingThisTask) {
            toast.error("You can't change importance while editing this task.");
            return;
        }

        try {
            const response = await toggleTaskImportant(id, important);
            if (response?.data?.stat === "ok") {
                fetchTaskLists({ selectedDate });
                fetchStaticTaskList();
                //refetchProfile();
                refetchTaskList();
                toast.success(important ? "Task marked as normal" : "Task marked as important");
            } else {
                throw new Error("Failed to update task importance");
            }
        } catch (error) {
            toast.error("Failed to update task importance");
        }
    };

    const handleCardClick = (e) => {
        if (!e.target.closest(".action-bar") && !e.target.closest(".selection-circle")) {
            if (onToggleExpand) {
                onToggleExpand();
            } else {
                setLocalIsExpanded(!localIsExpanded);
            }
        }
    };

    const handleTaskDeleteClick = () => {
        if (hasTaskPermission && handleNoPermission) {
            if (!hasTaskPermission(task)) {
                handleNoPermission();
                return;
            }
        } else if (task.customerHappiness === 1 && user?.permissions?.CUSTOMER_HAPPINESS_TASK === 0) {
            toast.error("You do not have permission to delete this task.");
            return;
        }
        if (isEditingThisTask) {
            toast.error("You can't delete this task while editing.");
            return;
        }
        setState({
            selectedModal: isProfileTask ? modals.DELETE_PROFILE_TASK : modals.DELETE_TASK,
            modalMessage:
                !!task.assignedById && user.id !== task.assignedById
                    ? "This task has been assigned to you by other user. Are you sure you want to delete it?"
                    : "Are you sure you want to delete this task?",
        });
        setTaskToDelete(id);
    };

    const handleOtherClick = (e) => {
        e.stopPropagation();
        setSelectedTaskForMove(task);
        setShowDatePicker(true);
        // Scroll the datepicker into view after it renders
        setTimeout(() => {
            if (datePickerWrapperRef.current) {
                datePickerWrapperRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
        }, 100);
    };

    const handleDateChange = (date) => {
        if (date) {
            const selectedDate = new Date(date);
            const currentDate = new Date(zaman);
            const timeDiff = selectedDate.getTime() - currentDate.getTime();
            const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

            handleMove(daysDiff, true); // from Other date picker: use task date + days
            setShowDatePicker(false);
            setSelectedTaskForMove(null);
        }
    };

    const moveOptions = [
        { label: "+7 days", value: 7 },
        { label: "+3 days", value: 3 },
        { label: "+1 day", value: 1 },
        { label: "Other", value: "other" },
    ];

    const handleMove = async (days, fromOtherDatePicker = false) => {
        if (hasTaskPermission && handleNoPermission) {
            if (!hasTaskPermission(task)) {
                handleNoPermission();
                return;
            }
        }

        try {
            if (days === "other") {
                return;
            }

            const originalTime = moment(zaman);
            let newDate;

            if (fromOtherDatePicker) {
                // Other: selected date = task date + daysDiff (so we get the exact picked date)
                newDate = moment(zaman)
                    .add(days, "days")
                    .hour(originalTime.hour())
                    .minute(originalTime.minute())
                    .second(originalTime.second())
                    .valueOf();
            } else {
                // +1 / +3 / +7: for overdue use today + days; for future use task date + days
                const isOverdue = moment(zaman).isBefore(moment(), "day");
                if (isInOverduesPage || isOverdue) {
                    const today = moment().startOf("day");
                    newDate = today
                        .add(days, "days")
                        .hour(originalTime.hour())
                        .minute(originalTime.minute())
                        .second(originalTime.second())
                        .valueOf();
                } else {
                    newDate = moment(zaman)
                        .add(days, "days")
                        .hour(originalTime.hour())
                        .minute(originalTime.minute())
                        .second(originalTime.second())
                        .valueOf();
                }
            }

            await updateTask({
                taskId: id,
                taskText: title,
                currentDate: newDate,
                profileId,
                daysToAdd: 0, // We're setting the exact date, not adding days
                important,
            });
            fetchTaskLists({ selectedDate });
            fetchStaticTaskList();
            //refetchProfile();
            refetchTaskList();
            toast.success(`Task moved by ${days} day${Math.abs(days) !== 1 ? "s" : ""}`);
        } catch (error) {
            toast.error("Failed to move task");
        }
    };

    const actionButtons = [
        ...(isCompletedTask
            ? []
            : [
                  {
                      variant: "success",
                      onClick: (e) => {
                          e.stopPropagation();
                          if (hasTaskPermission && handleNoPermission) {
                              if (!hasTaskPermission(task)) {
                                  handleNoPermission();
                                  return;
                              }
                          }
                          if (isEditingThisTask) {
                              toast.error("You can't complete this task while editing.");
                              return;
                          }
                          handleTaskCompletion(id);
                      },
                      text: "Complete",
                  },
              ]),
        {
            variant: "passive",
            component: (
                <MoveButtonWrapper
                    key="move-button"
                    onClick={(e) => e.stopPropagation()}
                    showDatePicker={showDatePicker && selectedTaskForMove && selectedTaskForMove.id === id}
                    onMouseEnter={() => setIsMoveHovered(true)}
                    onMouseLeave={() => setIsMoveHovered(false)}
                >
                    <ButtonWithText
                        variant="passive"
                        buttonStyle="borderless"
                        size="xsmall"
                        onClick={(e) => {
                            e.stopPropagation();
                            if (isEditingThisTask) {
                                toast.error("You can't move this task while editing.");
                                return;
                            }
                        }}
                        style={{ padding: "0px" }}
                    >
                        Move
                    </ButtonWithText>
                    {!isEditingThisTask && (
                        <>
                            <MoveDropdown
                                isFirst={index < 2}
                                isProfileTaskFirst={isProfileTaskFirst && index === 0}
                                $datePickerOpen={showDatePicker && selectedTaskForMove && selectedTaskForMove.id === id}
                            >
                                {moveOptions.map((option) => (
                                    <MoveOption
                                        key={option.value}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            option.value === "other" ? handleOtherClick(e) : handleMove(option.value);
                                        }}
                                    >
                                        {option.label}
                                    </MoveOption>
                                ))}
                            </MoveDropdown>
                            {showDatePicker && selectedTaskForMove && selectedTaskForMove.id === id && (
                                <DatePickerWrapper
                                    ref={datePickerWrapperRef}
                                    isFirst={isFirst}
                                    isProfileTaskFirst={isProfileTaskFirst && index === 0}
                                    isProfileTask={isProfileTask}
                                    isCompletedTask={isCompletedTask}
                                    onClick={(e) => e.stopPropagation()}
                                    onMouseDown={(e) => e.stopPropagation()}
                                >
                                    <CustomDatePicker
                                        componentVariant="l3rnTech"
                                        variant="move-dropdown"
                                        onChange={handleDateChange}
                                        onClickOutside={() => {
                                            setShowDatePicker(false);
                                            setSelectedTaskForMove(null);
                                        }}
                                    />
                                </DatePickerWrapper>
                            )}
                        </>
                    )}
                </MoveButtonWrapper>
            ),
        },
        { variant: "danger", onClick: handleTaskDeleteClick, text: "Delete" },
        {
            variant: "l3rnTech",
            component: (
                <ButtonWithText
                    key="edit-button"
                    onClick={(e) => {
                        e.stopPropagation();
                        if (hasTaskPermission && handleNoPermission) {
                            if (!hasTaskPermission(task)) {
                                handleNoPermission();
                                return;
                            }
                        }

                        setState({
                            popupContent: POPUP_CONTENTS.NEW_TASK,
                            popupIsOpen: true,
                            taskPage: true,
                            selectedTask: task,
                            editMode: true,
                        });
                    }}
                    variant="l3rnTech"
                    buttonStyle="borderless"
                    size="xsmall"
                    style={{ padding: "0px" }}
                >
                    Edit
                </ButtonWithText>
            ),
        },
    ];

    const openInNewTabProfileClick = (id) => {
        window.open(`/extension?profileId=${id}`, "_blank");
    };

    const descriptionContent =
        relatedCustomer && !isExpanded
            ? title + " | " + '<span style="color: #2b2b75;">' + relatedCustomer + "</span>"
            : title;

    return (
        <CardContainer
            overdue={overdue}
            isExpanded={isExpanded}
            hideBulkActions={hideBulkActions}
            showDatePicker={showDatePicker}
            showInlineInfo={showInlineInfo}
            isMoveHovered={isMoveHovered}
            onClick={handleCardClick}
        >
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id="tooltip-important" style={{ zIndex: "10000" }}>
                        {important === 1 ? "Click to mark as normal" : "Click to mark as important"}
                    </Tooltip>
                }
            >
                <ImportantBadge important={important === 1} onClick={handleImportantToggle}>
                    !
                </ImportantBadge>
            </OverlayTrigger>
            <input
                type="checkbox"
                name="task-selection"
                checked={selectedTasks.includes(id)}
                onChange={handleCheckboxClick}
                style={{ display: "none" }}
            />

            <CardContent isProfileTask={isProfileTask}>
                <ContentWrapper isExpanded={isExpanded}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "0px 4px" }}>
                        {/* selection checkbox moved outside card in ExtensionTaskList */}
                        <div style={{ width: "100%" }}>
                            {isProfileTask && (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <span style={{ color: colors.neutral[800], fontSize: "12px" }}>
                                        {moment(zaman).format("MMM DD, YYYY - HH:mm")}
                                    </span>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        {taskColor && <UserStatus style={{ backgroundColor: taskColor }} />}
                                        <TypeInfo style={{ fontSize: "12px" }}>{type}</TypeInfo>
                                    </div>
                                </div>
                            )}
                            <Title
                                selected={selectedTasks.includes(id)}
                                isExpanded={isExpanded}
                                showInlineInfo={showInlineInfo}
                            >
                                <TypeInfoWrapper>
                                    {!isProfileTask && (
                                        <div
                                            className="task-type-info"
                                            style={{ display: "flex", alignItems: "center", gap: "8px" }}
                                        >
                                            {taskColor && <UserStatus style={{ backgroundColor: taskColor }} />}
                                            <TypeInfo style={isInOverduesPage ? { fontSize: "11px" } : undefined}>
                                                {type}
                                            </TypeInfo>
                                        </div>
                                    )}
                                    <ExpandableBox data-task-content={id} $expanded={isExpanded}>
                                        <StyledNoteContent
                                            isRelatedCustomer={relatedCustomer ? true : false}
                                            variant={"notEdit"}
                                            dangerouslySetInnerHTML={{
                                                __html: highlightFromTo(descriptionContent),
                                            }}
                                        />
                                    </ExpandableBox>
                                </TypeInfoWrapper>
                            </Title>
                            {description && (
                                <>
                                    <Description selected={selectedTasks.includes(id)}>{description}</Description>
                                </>
                            )}
                        </div>
                    </div>

                    <DetailContent isExpanded={isExpanded}>
                        {hasUserInfo && (
                            <>
                                <Separator />
                                <UserInfoWrapper
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openInNewTabProfileClick(profileId);
                                    }}
                                    isExpanded={isExpanded}
                                >
                                    <UserInfo>
                                        <UserAvatar
                                            src={imgSrc}
                                            alt={userName}
                                            onError={() => setImgSrc(defaultImage)}
                                        />
                                        <UserName>{userName}</UserName>
                                        {profileId && (
                                            <ButtonWithText
                                                label="Open profile"
                                                iconType={"material"}
                                                variant="l3rnTech"
                                                size="small"
                                                buttonStyle="borderless"
                                                icon={"open_in_new"}
                                            ></ButtonWithText>
                                        )}
                                    </UserInfo>
                                </UserInfoWrapper>
                            </>
                        )}
                        {hasUserInfo && <Separator />}

                        {(activity || accountName) && (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                }}
                            >
                                {activity && (
                                    <DetailItem
                                        selected={selectedTasks.includes(id)}
                                        weight={500}
                                        style={{ cursor: "pointer" }}
                                    >
                                        {activity.subject}
                                        <ButtonWithText
                                            label="Open activity"
                                            iconType={"material"}
                                            variant="l3rnTech"
                                            size="small"
                                            buttonStyle="borderless"
                                            icon={"open_in_new"}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (activity.id) {
                                                    window.open(`/activities?activityId=${activity.id}`, "_blank");
                                                }
                                            }}
                                        ></ButtonWithText>
                                    </DetailItem>
                                )}
                                {accountName && (
                                    <DetailItem selected={selectedTasks.includes(id)} weight={400}>
                                        {accountName}
                                    </DetailItem>
                                )}
                            </div>
                        )}

                        {hasDetailItems && (
                            <IconDetailWrapper>
                                {profil &&
                                    [phoneNumber, tel2, tel3].filter(Boolean).map((phone, index) => (
                                        <IconDetailItem key={`phone-${index}`} selected={selectedTasks.includes(id)}>
                                            <span className="material-symbols-outlined">call</span>
                                            {phone}
                                        </IconDetailItem>
                                    ))}

                                {profil &&
                                    [email, email2].filter(Boolean).map((emailAddress, index) => (
                                        <IconDetailItem key={`email-${index}`} selected={selectedTasks.includes(id)}>
                                            <span className="material-symbols-outlined">mail</span>
                                            {emailAddress}
                                        </IconDetailItem>
                                    ))}
                            </IconDetailWrapper>
                        )}
                        {(assignedTo || kayitci || zaman) && <Separator />}
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                            {assignedTo && assignedTo !== kayitci && (
                                <AssignedText>Assigned To {assignedTo}</AssignedText>
                            )}
                            {kayitci && <AssignedText>Created by {kayitci}</AssignedText>}
                            {zaman && !isInOverduesPage && (
                                <CreatedText>
                                    Created on {moment(createdTime).format("MMM DD, YYYY - HH:mm")}
                                </CreatedText>
                            )}
                        </div>
                    </DetailContent>
                </ContentWrapper>
            </CardContent>

            <ActionBar
                className="action-bar"
                $elevated={isMoveHovered || (showDatePicker && selectedTaskForMove && selectedTaskForMove.id === id)}
            >
                {actionButtons.map((button) =>
                    button.component ? (
                        button.component
                    ) : (
                        <ButtonWithText
                            key={button.text}
                            size="xsmall"
                            variant={button.variant}
                            buttonStyle="borderless"
                            onClick={button.onClick}
                            style={{ padding: "0px" }}
                        >
                            {button.text}
                        </ButtonWithText>
                    )
                )}
            </ActionBar>
        </CardContainer>
    );
};

export default SelectableTaskCard;
